<template>
  <div>
    <!-- Modal พัสดุ -->
    <b-modal centered no-close-on-backdrop no-close-on-esc v-model="modelParcelShow" @close="closeParcel"
             size="xl" hide-footer no-stacking>
      <!-- :no-stacking="(checkThemeQuick()) ? false : true" -->
      <template slot="modal-title" class="w-100">
        <div slot="header" class="bg-white border-0" ref="model-parcel-header">
          <div class="row align-items-center">
            <div class="col-6 d-flex align-items-center">
              <h3 class="mb-0">
                ข้อมูลการจัดส่ง
                <span>{{ activeCourierItem.expressName }}</span>
              </h3>

              <img class="card-img-top img-mx-100 pl-3" :src="activeCourierItem.expressUrl"
                   img-alt="Image" />
            </div>
          </div>
        </div>
      </template>
      <card shadow type="secondary" class="m--4">
        <template>
          <!--    切换地址    -->
          <template>
            <h6 class="heading-small text-muted mb-4 ">
              <span>ต้นทางที่แสดงบนใบปะหน้า (เข้ารับพัสดุที่ร้าน)</span>
              <!--            <span v-else>ต้นทางที่เข้ารับพัสดุ</span>-->
            </h6>
            <div class="d-flex justify-content-between align-items-center mb-4">
              <b-form-checkbox size="lg" v-model="from.source" value=1 @change="changSource" unchecked-value=0>
                <span>ใช้ต้นทางนี้เป็นที่อยู่ในการเข้ารับพัสดุ</span>
              </b-form-checkbox>
              <div class="switch-pos">
                <!-- <div class="form-group"> -->
                <div class="d-flex align-items-center">
                  <span>ที่อยู่ตามบัตรประชาชน</span>
                  <b-form-checkbox switch size="lg" v-model="isToggle" @input="sameSender"></b-form-checkbox>
                  <span>ที่อยู่ร้าน</span>
                </div>
                <!-- </div> -->
              </div>
            </div>
          </template>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label floater><small class="text-danger">*</small> ชื่อ-นามสกุล</label>
                <input type="text" placeholder class="form-control"
                       v-model="from.name" :class="{ 'is-invalid': submitAddShipping && nameError }" />
                <div v-if="submitAddShipping && nameError" class="invalid-feedback">
                  กรุณากรอกชื่อ-นามสกุล</div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label floater><small class="text-danger">*</small> หมายเลขโทรศัพท์</label>

                <AutocompletesOrigin ref="fromTel"
                                     :endpoint="'/origin/${param}/details'" :data="from.tel" @select:item="onSubmitOriginAutocomp"
                                     @input="from.tel = $event.target.value"
                                     :class="{ 'is-invalid': submitAddShipping && telError }">
                  <template slot="custom-items" slot-scope="props">
                    <h6>
                      ชื่อ:{{ props.data.name }} เบอร์:{{ props.data.tel }} ที่อยู่:{{ props.data.address }}
                      ตำบล:{{ props.data.district }}
                      อำเภอ:{{ props.data.state }}
                      จังหวัด:{{ props.data.province }}
                      รหัสปณ.:{{ props.data.postcode }}
                    </h6>
                  </template>
                </AutocompletesOrigin>
                <div v-if="submitAddShipping && telError ===1" class="invalid-feedback d-block">
                  กรุณากรอกหมายเลขโทรศัพท์</div>
                <div class="error invalid-feedback d-block" v-if="submitAddShipping && telError ===2">
                  กรุณากรอก"หมายเลขโทรศัพท์"อย่างน้อย {{ from.tel.length }} หลัก</div>
                <div class="error invalid-feedback d-block" v-if="submitAddShipping && telError ===3">
                  กรุณากรอก"หมายเลขโทรศัพท์"ไม่เกิน {{ from.tel.length }} หลัก</div>
                <div class="error invalid-feedback" v-if="submitAddShipping && telError ===4">
                  กรุณากรอกเฉพาะตัวเลข</div>
                <!--              <div class="error invalid-feedback" v-if="submitAddShipping && telError ===4">-->
                <!--                กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง</div>-->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label floater><small class="text-danger">*</small> ที่อยู่</label>

                <input type="text" placeholder class="form-control"
                       v-model="from.address" :class="{ 'is-invalid': submitAddShipping && from.address.$error }" />

                <div v-if="submitAddShipping && !from.address.required" class="invalid-feedback">
                  กรุณากรอกที่อยู่</div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6" v-if="checkThemeQuick()">
              <div class="form-group">
                <label floater>
                  <small class="text-danger">*</small> รหัสไปรษณีย์
                </label>
                <AutocompletesAddress :queryInput="from.postcode"
                                      :adsTypes="'postcode'" :class="{
                            'is-invalid': submitAddShipping &&
                              from.postcode.$error ||
                              from.postcode.status
                          }" @input="from.postcode = $event.target.value"
                                      @select:item="onSubmitAddress($event, 'from')">
                </AutocompletesAddress>
                <div v-if="from.postcode.status" class="invalid-th-address">
                  {{ from.postcode }}
                </div>
                <div v-if="submitAddShipping && !from.postcode.required" class="invalid-th-address">
                  กรุณากรอกรหัสไปรษณีย์</div>
                <div class="error invalid-th-address" v-if="submitAddShipping && !from.postcode">
                  กรุณากรอก"รหัสไปรษณีย์" {{ from.postcode}} หลัก</div>
                <div class="error invalid-th-address" v-if="submitAddShipping && !from.postcode">
                  กรุณากรอก"รหัสไปรษณีย์" {{ from.postcode }} หลัก</div>
                <div class="error invalid-th-address" v-if="submitAddShipping && !from.postcode">
                  กรุณากรอกเฉพาะตัวเลข</div>
              </div>
              <!-- รหัสไปรษณีย์ -->
            </div>
            <div :class="['col-12 col-md-6', (checkThemeQuick()) ? 'col-lg-4' : 'col-lg-6']">
              <div class="form-group">
                <label floater>
                  <small class="text-danger">*</small> ตำบล/แขวง
                </label>
                <AutocompletesAddress :queryInput="from.state"
                                      :adsTypes="'sub-district'" :class="{
                            'is-invalid':
                              submitAddShipping &&
                              from.state.$error ||
                              from.state.status
                          }" @input="from.state = $event.target.value" @select:item="onSubmitAddress($event, 'from')">
                </AutocompletesAddress>

                <div v-if="from.state.status" class="invalid-th-address">
                  {{ from.state }}
                </div>
                <div v-if="submitAddShipping && !from.state.required" class="invalid-th-address">
                  กรุณากรอกตำบล/แขวง</div>
              </div>
              <!-- ตำบล/แขวง -->
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <div class="form-group">
                <label floater>
                  <small class="text-danger">*</small> อำเภอ/เขต
                </label>
                <AutocompletesAddress :queryInput="from.district"
                                      :adsTypes="'district'" :class="{
                            'is-invalid':
                              submitAddShipping &&
                              from.district.$error ||
                              from.district.status
                          }" @input="from.district = $event.target.value"
                                      @select:item="onSubmitAddress($event, 'from')">
                </AutocompletesAddress>

                <div v-if="from.district.status" class="invalid-th-address">
                  {{ from.district }}
                </div>
                <div v-if="submitAddShipping && !from.district.required" class="invalid-th-address">
                  กรุณากรอกอำเภอ/เขต</div>
              </div>
              <!-- อำเภอ/เขต -->
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <div class="form-group">
                <label floater>
                  <small class="text-danger">*</small> จังหวัด
                </label>
                <AutocompletesAddress :queryInput="from.province"
                                      :adsTypes="'province'" :class="{
                            'is-invalid':
                              submitAddShipping &&
                              from.province.$error ||
                              from.province.status
                          }" @input="from.province = $event.target.value"
                                      @select:item="onSubmitAddress($event, 'from')">
                </AutocompletesAddress>
                <div v-if="from.province.status" class="invalid-th-address">
                  {{ from.province }}
                </div>
                <div v-if="submitAddShipping && !from.province.required" class="invalid-th-address">
                  กรุณากรอกจังหวัด</div>
              </div>
              <!-- จังหวัด -->
            </div>
            <div class="col-lg-4 col-12 col-md-6" v-if="!checkThemeQuick()">
              <div class="form-group">
                <label floater>
                  <small class="text-danger">*</small> รหัสไปรษณีย์
                </label>
                <AutocompletesAddress :disableInput="checkDropoffEasyShip()" :queryInput="from.postcode"
                                      :adsTypes="'postcode'" :class="{
                            'is-invalid': submitAddShipping &&
                              from.postcode.$error ||
                              from.postcode.status
                          }" @input="from.postcode = $event.target.value"
                                      @select:item="onSubmitAddress($event, 'from')">
                </AutocompletesAddress>
                <div v-if="from.postcode.status" class="invalid-th-address">
                  {{ from.postcode }}
                </div>
                <div v-if="submitAddShipping && !from.postcode.required" class="invalid-th-address">
                  กรุณากรอกรหัสไปรษณีย์</div>
                <div class="error invalid-th-address" v-if="submitAddShipping && !from.postcode">
                  กรุณากรอก"รหัสไปรษณีย์" {{ from.postcode}} หลัก</div>
                <div class="error invalid-th-address" v-if="submitAddShipping && !from.postcode">
                  กรุณากรอก"รหัสไปรษณีย์" {{ from.postcode }} หลัก</div>
                <div class="error invalid-th-address" v-if="submitAddShipping && !from.postcode">
                  กรุณากรอกเฉพาะตัวเลข</div>
              </div>
              <!-- รหัสไปรษณีย์ -->
            </div>
          </div>
          <hr class="my-4" />
        </template>
        <!-- Address -->
        <h5 class="text-muted w-100" style="font-size: 20px">ปลายทาง</h5>
        <div class="d-flex justify-content-between mb-4" ref="model-parcel-destination">
          <div style="display: flex;align-items:flex-start;justify-content: flex-start">
            <button class="btn btn-primary excel-download-button mr-3" @click="showAddReceiverInfo">添加收件人</button>
            <div>
              <button class="btn btn-primary excel-download-button mr-3" @click="importExcelFile">批量上传</button>
              <input style="display:none;" type="file" id="file" name="file" multiple accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @change="getUploadFile" />
            </div>
            <button class="btn  mr-4" variant="link" @click="importExcelTemp">批量模版下载</button>
          </div>
<!--          <b-input-group style="width: 50%">-->
<!--            <b-form-input></b-form-input>-->
<!--            <b-input-group-append>-->
<!--              <b-button variant="outline-success">查 询</b-button>-->
<!--            </b-input-group-append>-->
<!--          </b-input-group>-->
        </div>
        <div class="table-responsive scroll-bar-pop">
          <b-table
              show-empty
              stacked="md"
              :items="members"
              :fields="fields"
              :busy="busy"
              :tbody-tr-class="rowClass"
          >
            <div slot="table-busy" class="text-center">
              <BlockUI>
                <div class="loader"></div>
              </BlockUI>
            </div>
            <template slot="index" slot-scope="data">{{ data.index + 1 }}</template>

            <template slot="index" slot-scope="data">
              <span>{{data.item.detail.senderName}}</span><br>
              <span>{{ data.index + 1 }}</span>
            </template>
            <template slot="reveiver" slot-scope="row">
              <h3>{{row.item.detail.receiverName}} {{row.item.detail.receiverPhone}}</h3>
              <span>
              {{row.item.detail.receiverAddress}}-{{row.item.detail.receiverPostcode}}-{{row.item.detail.receiverDistrict}}-{{row.item.detail.receiverCity}}-{{row.item.detail.receiverProvince}} <br>
            </span>
              <span v-if="row.item.detail.codAmount" class="pr-2">COD:{{row.item.detail.codAmount}} </span>
              <span v-if="row.item.detail.isSpeed" class="pr-2">SPEED</span>
              <span v-if="row.item.detail.insureAmount" class="pr-2">Insurance</span>
            </template>
            <template slot="parcelInfo" slot-scope="row">
              <b-badge variant="success" style="font-size: 12px" pill v-if="row.item.detail.payStatus === 2">已支付</b-badge>
              <b-badge variant="danger" style="font-size: 12px" pill v-if="row.item.detail.payStatus === 1 && row.item.detail.pkgStatus === -1">
                {{ row.item.detail.errorMessage }}</b-badge>
              <b-badge variant="primary" style="font-size: 12px" pill v-if="row.item.detail.payStatus === 1 && row.item.detail.pkgStatus !== -1">待支付</b-badge><br>
              <span>{{row.item.detail.pkgCategoryName}}-{{row.item.detail.pkgWeight}}kg-{{row.item.detail.pkgWidth}}cm-{{row.item.detail.pkgLenght}}cm-{{row.item.detail.pkgHeight}}cm </span><br>
              <span>
              备注：{{row.item.detail.pkgDesc}}<br>
            </span>
            </template>
            <template slot="manage" slot-scope="row">
              <button
                  class="btn px-3 btn-sm btn-info"
                  v-if="row.item.detail.payStatus === 1"
                  @click="showEditPackage(row.item)"
              >แก้ไข</button>
              <button
                  class="btn px-3 btn-sm btn-info"
                  v-if="row.item.detail.payStatus === 1"
                  @click="fnDeleteExpressPkg(row.item)"
              >删除</button>
            </template>
            <template #row-details="row">
                <b-row class="mb-2" v-if="row.item.detail.errorMessage">
                  <b-col>{{ row.item.detail.errorMessage }}</b-col>
                </b-row>
            </template>

          </b-table>
        </div>
        <div class="mt-4 w-100 text-right">
          <b-button
              variant="secondary"
              class="mx-3"
              @click="closeParcel()"
          >
            ยกเลิก
          </b-button>
          <b-button
              type="submit"
              class="w-10"
              variant="success"
              @click="ConfirmOrder()"
          >ยืนยัน</b-button>
        </div>
      </card>
    </b-modal>
    <AddReceiverInfo :cashNumberInfo="cashNumberInfo" ref="addReceiverInfo" @showAddParcelInfo="showAddParcelInfo" :activeCourierItem="activeCourierItem"></AddReceiverInfo>
  </div>

</template>
<script>
import InputParcelType from "@/components/custom/pos/InputParcelType.vue";
import AutoBox from "@/components/AutoBox.vue";
import AutocompletesOrigin from "@/components/Autocomplete/Autocompletes.vue";
import ParcelInsurance from "@/components/custom/pos/ParcelInsurance.vue";
import AutocompletesAddress from "@/components/Autocomplete/AddressTH/AutocompleteAddressTH.vue";
import RadioBox from "@/components/custom/pos/RadioBox.vue";
import SearchTracking from "@/components/custom/pos/SearchTracking.vue";
import PosComponents from "@/components/custom/pos/import";
import ImportExcel from "@/components/custom/pos/ImportExcel.vue";
import AddReceiverInfo from "@/views/Pos/components/AddReceiverInfo.vue"
import {
  deleteExpressPkg,
  excelWithChannel,
  getExcelTemplate,
  getPosDetailByCashNum,
  getPosRecentlyList
} from "@/api/express";
import * as XLSX from "xlsx";
const ERROR_MSG = {
  invaid_format: 'กรุณากรอกข้อมูลตาม รูปแบบที่กำหนด',
  invaid_length: 'กรุณาสร้างรายการทีละ 50 รายการ'
}

export default{
  components:{
    ImportExcel,
    InputParcelType,
    AutoBox,
    AutocompletesOrigin,
    ParcelInsurance,
    AutocompletesAddress,
    RadioBox,
    SearchTracking,
    'CreateOrderByExcel': PosComponents.CreateOrderByExcel,
    AddReceiverInfo
  },
  props:{
    activeCourierItem:{
      type:Object,
      default:() => {}
    },
    cashNumberInfo:{
      type:Object,
      default:() => {}
    },
    from:{
      type:Object,
      default:{
        source: 0,
        address: "",
        district: "",
        latlng: "",
        name: "",
        postcode: "",
        province: "",
        state: "",
        tel: "",
        email: "",
        areaCode:''
      }
    },
    agentInfo:{
      type:Object,
      default:() => {}
    }
  },
  data(){
    return {
      modelParcelShow:false,
      submitAddShipping:false,
      orderExcel: {
        error: []
      },
      members: [],
      fields: [
        { key: "index", label: "#"},
        { key: "reveiver", label: "收件人信息" },
        { key: "parcelInfo", label: "包裹信息" },
        { key: "manage", label: "การจัดการ", sortable: false }
      ],
      filter: null,
      busy:true,
      selectSender:{}

    }
  },
  computed: {
    // 手机号校验
    telError() {
      if (!this.from.tel) {
        return 1
      } else if (this.from.tel && this.from.tel.length < 9) {
        return 2
      } else if (this.from.tel && this.from.tel.length > 10) {
        return 3
      } else {
        console.log(/\D/.test(this.from.tel))
        if (/\D/.test(this.from.tel)) {
          return 4
        } else {
          return 0
        }
      }
    },
    // 名字校验
    nameError() {
      if (!this.from.name) {
        return 1
      } else {
        if (this.from.name.length > 50) {
          console.log(this.from.name.length)
          return 2
        } else {
          return 0
        }
      }
    },
    checkErrorCreateOrderByExcel: {
      get() {
        return this.orderExcel.error
      },
      set(value) {
        if (value === true || value.status === true) {
          return this.orderExcel.error = []
        }
        let res = {
          header: null,
          body: null
        }
        const typeInvalidExcel = 'invaid_format'
        const typeInvalidLengthExcel = 'invaid_length'
        value.error.forEach(error => {
          if (error.type === typeInvalidExcel) {
            res.header = 'รูปแบบไฟล์ไม่ถูกต้อง'
            res.body = error.msg
          } else if (error.type === typeInvalidLengthExcel) {
            res.header = 'ทำรายการเกินจำนวนออเดอร์ที่กำหนด'
            res.body = error.msg
          }
          this.orderExcel.error.push(res)
        })
      }
    },
  },
  methods:{
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.detail.pkgStatus === -1) return 'table-danger'
    },
    // 批量导入
    async importExcelFile () {
        var file = document.getElementById('file')
        file.click()
        // 清空文件的值，不然第二次点击上传无效
        file.value = ''
    },
    getUploadFile (e) {
      console.log(this.$store.state.cashNum)
      // 文件校验
      // 拿到所导入文件的名字
      let file = e.target.files[0]
      //定义reader，存放文件读取方法
      let reader = new FileReader()
      //启动函数
      reader.readAsBinaryString(file)
      //onload在文件被读取时自动触发
      reader.onload = (e) => {
        //workbook存放excel的所有基本信息
        let workbook = XLSX.read(e.target.result, { type: 'binary' })
        //定义sheetList中存放excel表格的sheet表，就是最下方的tab, 这里因为业务上的要求，只取一个
        let sheetList = workbook.SheetNames.splice(0, 1)
        sheetList.forEach((y) => {
          let worksheet = workbook.Sheets[y]
          let json = XLSX.utils.sheet_to_json(worksheet)
          // 如果excel里面有一列是区市省合并的表头，就简单认定是新模板
          let key = json.find(item => item.__EMPTY_3 === '*พื้นที่บริการ ที่อยู่โดยละเอียด ตำบล/อำเภอ/จังหวัด/รหัสไปรษณีย์')
          if (key) {
            let params = {
              senderArea:this.from.areaCode,
              senderProvince:this.from.province,
              senderCity:this.from.district,
              senderDistrict:this.from.state,
              senderStreet:'',
              senderAddress:this.selectSender.address,
              senderName:this.from.name,
              senderPhone:this.from.tel,
              senderPostcode:this.from.postcode,
              expressId:this.activeCourierItem.id,
              expressCode:this.activeCourierItem.expressCode,
              isCod:0,
              codInfoId:'0',
              expressCodAccount:'0',
              cashNum:this.$store.state.cashNum
            }
            let data = new FormData();
            console.log(file)
            console.log(params)
            data.append('file', file)
            Object.keys(params).forEach(key => {
              data.append(key, params[key])
            })
            console.log(data)
            this.fnExcelWithChannel(data)
          } else {
            return
            // this.$message.warning(this.$t('allSend.importNewTemp'))
          }
        })
      }
      // 清空文件的值，不然第二次点击上传无效
      e.target.value = ''
    },
    // 批量导入
    fnExcelWithChannel(data){
      excelWithChannel(data)
          .then((res) => {
            this.modelGetPosRecentlyList()
          })
    },
    checkThemeQuick() {
      return 'quickexpress';
    },
    fnGetPosRecentlyList(key) {
      this.$emit('fnGetPosRecentlyList')
    },
    modelGetPosRecentlyList(){
      getPosDetailByCashNum(this.$store.state.cashNum)
          .then((res) => {
            console.log(res.data.detail)
            this.members = res.data.detail
            this.busy = false
          })
    },
    showAddParcelInfo(){
      this.selectSender = JSON.parse(localStorage.getItem('senderInfo'))
      this.from.source= 0
      this.from.address = this.selectSender.address
      this.from.district = this.selectSender.district
      this.from.latlng = this.selectSender.latlng
      this.from.name = this.selectSender.name
      this.from.postcode = this.selectSender.postcode
      this.from.province = this.selectSender.province
      this.from.state = this.selectSender.state
      this.from.tel = this.selectSender.tel
      this.from.email = this.selectSender.email
      this.from.areaCode = this.selectSender.areaCode
      getPosDetailByCashNum({
        cashNum:this.$store.state.cashNum,
        isError:true,
        isHaveShop:false
      })
          .then((res) => {
            console.log(res.data.detail)
            this.members = res.data.detail
            this.busy = false
          })
      this.modelParcelShow = true
    },
    showAddReceiverInfo(){
      this.$refs.addReceiverInfo.showAddReceiverInfo()
    },
    closeParcel(){
      this.modelParcelShow = false
    },
    ConfirmOrder(){
      this.$emit('fnGetPosRecentlyList')
      this.modelParcelShow = false
    },
    sameSender(){
      if (this.isToggle == false) {
        this.from.name = this.selectSender.name
        this.from.address = this.selectSender.address
        this.from.state = this.selectSender.state
        this.from.district = this.selectSender.district
        this.from.province = this.selectSender.province
        this.from.postcode = this.selectSender.postcode
        this.from.tel = this.selectSender.tel
        this.from.areaCode = this.selectSender.areaCode
        localStorage.setItem("senderInfo", JSON.stringify(this.from))
        this.titleName = "ที่อยู่ตามบัตรประชาชน"
      } else {
        this.from.name = this.agentInfo.agentName
        this.from.address = this.agentInfo.address
        this.from.state = this.agentInfo.district
        this.from.district = this.agentInfo.city
        this.from.province = this.agentInfo.province
        this.from.postcode = this.agentInfo.postCode
        this.from.tel = this.agentInfo.mobile
        this.from.areaCode = this.selectSender.areaCode
        localStorage.setItem("senderInfo", JSON.stringify(this.from))
        this.titleName = "ที่อยู่ร้าน"
      }
    },
    changSource(){
      console.log(this.from.source)
    },
    isToggle(){

    },
    onSubmitOriginAutocomp(item) {
      Object.keys(this.from).forEach(key => {
        if (item[key]) {
          this.from[key] = item[key]
        } else {
          this.from[key] = this.from[key]
        }
      })
    },
    async createOrderByExcel(data) {
      this.addMoreOrder.isActive = true
      await this.closeParcel()
      this.busy = true
      this.checkErrorCreateOrderByExcel = data.status
      await this.setAction(ACTION_CREATE_ORDER.excel)
      for (const item of data.data) {
        try {
          await this.autoCheckPrice(item)
        } catch (err) {
          let _order = this.addMoreOrder.order
          const lastIndexItem = _order.length - 1
          _order[lastIndexItem].error.status = true
          _order[lastIndexItem].error.data.push(err.error)
        }
      }
      this.addMoreOrder.isShow = true
      this.addMoreOrder.isActive = true
      this.addMoreOrder.typeCourier = this.preBarcode
      await this.clearValueOnCloseModalParcel()
      this.busy = false
    },
    // 获取地址列表信息
    async onSubmitAddress(ads, objKey) {
      Object.keys(this[objKey]).forEach(key => {
        if (ads[key]) {
          this[objKey][key] = ads[key]
        } else if (key == 'state') {
          this[objKey]['state'] = ads['sub-district']
        }
        else {
          this[objKey][key] = this[objKey][key]
        }
      })

      if (objKey == 'to') {
        this.checkDestinationCourier()
        await this.callCheckProblemCategory()
      }

    },
    onUpload( e ){
      if( e.status === true &&  e.data.length > 0 && this.countColumn(e.data) && this.countRow(e.data) ){
        this.json = e.data
        this.responseSuccess( this.json )
      }else{
        let typeError = '';
        let msgError = '';
        if( !this.countRow(e.data) ){
          typeError = 'invaid_length';
          msgError = ERROR_MSG.invaid_length
        }else{
          typeError = Object.keys( ERROR_MSG )[0];
          msgError = ERROR_MSG.invaid_format
        }
        this.error.push({
          type: typeError,
          msg: msgError
        })
        this.responseError( TYPR_ERROR_MSG[0] )

      }
    },
    importExcelTemp(){
      getExcelTemplate()
          .then((res) => {
            window.location.href = res.data.templateUrl
          })
    },
    fnDeleteExpressPkg(item){
      this.$bvModal
          .msgBoxConfirm('是否确认删除？', {
            title: "กรุณายืนยัน",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "ยืนยัน",
            cancelTitle: "ยกเลิก",
            contentClass: "modal-confirm",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            deleteExpressPkg({pkgId: item.orderId})
                .then((res) => {
                  console.log(res)
                  this.showAddParcelInfo()
                })
          })
          .catch(err => {
            // An error occurred
          })
    },
    showEditPackage(item){
        this.$refs.addReceiverInfo.showAddReceiverInfo(item)
    },
  }
}
</script>
